module.exports = __webpack_public_path__ + "img/20220527.e8bed62d.png";